// extracted by mini-css-extract-plugin
module.exports = {"main-card":"Brief_main-card__1qk38","card--header":"Brief_card--header__1RaT9","card":"Brief_card__3G_Co"};